<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table #packageListTable (custom)="prune($event)" icon="history" (detail)="onDetail($event)" (remove)="onRemove($event)"
              [columns]="columns" [title]="'Packages'" [dataProviderParams]="params" [dataProvider]="packageService" [searchAll]="true">
  </data-table>

</page-content>
